<template>
  <div class="w-100">
    <div style="width: 68%">
      <div class="d-flex">
        <div class="flex-grow-1 me-2">
          <div class="row">
            <div class="col" v-for="(title, i) in titleList" :key="i">
              <span class="text-danger" v-if="title.required">* </span>
              <label class="form-label">{{ title.name }}</label>
            </div>
          </div>
        </div>
        <!-- 占位 -->
        <div class="opacity-0">
          <b-button
            variant="primary"
            class="pb-0"
            size="sm"
            style="min-width: 4.5rem"
            >{{this.$t('page.solid')}}</b-button
          >
        </div>
      </div>
      <template v-if="showTags.length">
        <div class="d-flex mb-3" v-for="(tag, i) in showTags" :key="tag.id">
          <div class="flex-grow-1 me-2">
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  :class="[
                    'form-control',
                    tag.key && tag.key.length >= 50 && 'is-invalid',
                  ]"
                  :placeholder="this.$t('base.input_tag_name')"
                  v-model="tag.key"
                  maxlength="50"
                />
                <div
                  v-show="tag.key && tag.key.length >= 50"
                  class="invalid-feedback"
                >
                  <span>{{ validationTips.charLengthLE50 }}</span>
                </div>
              </div>
              <div class="col">
                <input
                  type="text"
                  :class="[
                    'form-control',
                    tag.value && tag.value.length >= 50 && 'is-invalid',
                  ]"
                  :placeholder="this.$t('base.input_tag_value')"
                  v-model="tag.value"
                  maxlength="50"
                />
                <div
                  v-show="tag.value && tag.value.length >= 50"
                  class="invalid-feedback"
                >
                  <span>{{ validationTips.charLengthLE50 }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="position-relative">
            <b-button
              variant="primary"
              size="sm"
              :style="{
                minWidth: '4.5rem',
                marginTop: ' 0.34rem',
                opacity: tag.disabled ? 0 : 1,
              }"
              :disabled="tag.disabled"
              @click="tagMessageBox = i"
              >{{this.$t('base.delete')}}</b-button
            >
            <MessageBox
              v-if="tagMessageBox == i"
              :messageCont="`${this.$t('page.product-library.AreYouSureWantDelete')}？`"
              :messageIcon="'ri-error-warning-line'"
              :iconStyle="{ fontSize: '14px', color: '#f06548' }"
              :messageStyle="{ top: '-6rem', left: '-3.5rem' }"
              @makeSure="handleDelete(i)"
              @makeClose="tagMessageBox = null"
            ></MessageBox>
          </div>
        </div>
      </template>
    </div>
    <div class="text-center mt-2">
      <b-button variant="primary" @click="handleAdd">{{this.$t('base.add_tag')}}</b-button>
    </div>
  </div>
</template>

<script>
import MessageBox from "@/components/common/MessageBox.vue";
import { v4 as uuidv4 } from "uuid";
export default {
  emits: ["update:tags"],
  props: {
    validationTips: Object,
    tags: {
      type: Array,
      default: () => {
        return [
          {
            key: "",
            value: "",
          },
        ];
      },
    },
  },
  data() {
    return {
      titleList: [
        {
          name: this.$t('page.work-order.device.name'),
          required: false,
        },
        {
          name: this.$t('page.work-order.value'),
          required: false,
        },
      ],
      showTags: [],
      tagMessageBox: null,
    };
  },
  components: {
    MessageBox,
  },
  watch: {
    showTags: {
      handler(newVal) {
        this.$emit("update:tags", newVal);
      },
      deep: true,
    },
    tags: {
      handler(val) {
        this.showTags = val;
      },
      deep: true,
    },
  },
  methods: {
    handleAdd() {
      this.tagMessageBox = null;
      let defaultData = {
        id: uuidv4(),
        key: "",
        value: "",
      };
      this.showTags.push({ ...defaultData });
    },
    handleDelete(i) {
      this.showTags.splice(i, 1);
      this.tagMessageBox = null;
    },
  },
};
</script>